export function strip_tags(htmlToCopy: string, tagsToKeep: string[]) {
  const tags = [];
  let tag = '';
  for (let a = 0; a < tagsToKeep.length; a++) {
    tag = tagsToKeep[a].replace(/<|>/g, '').trim();
    if (tagsToKeep[a].length > 0) {
      tags.push(tag, `/${tag}`);
    }
  }

  const html = htmlToCopy;
  if (typeof html !== 'string' || !html) {
    return '';
  } else if (tags.length === 0) {
    return html.replace(/<(\s*\/?)[^>]+>/g, '');
  } else {
    const re = new RegExp(`<(?!(${tags.join('|')})s*/?)[^>]+>`, 'g');
    return html.replace(re, '');
  }
}

export default function cleanMarkup(markup: string): string {
  let html = strip_tags(markup, ['a']);
  // 1. add "_top" target
  html = html.replace(/<a/g, '<a target="_top"');
  // 2. fix mailto links
  html = html.replace(
    /href="(.*?)&#109;&#97;&#105;&#108;&#116;&#111;&#58;(.*?)"/g,
    'href="mailto:$2"'
  );
  // 3. fix non-relative links
  html = html.replace(/href="\/(.*?)"/g, `href="https://bitbucket.org/$1"`);
  return html;
}
